import React, { FC, SVGProps } from 'react';

export const BaseProfileIcon: FC<SVGProps<SVGSVGElement>> = ({
  width = '20',
  height = '20',
  color = 'black',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M5.44358 10.4445H14.5547V12.1556H15.4436V9.55561H10.4436V7.77783H9.55469V9.55561H4.55469V12.1556H5.44358V10.4445Z"
      fill={color}
    />
    <path
      d="M7.77604 12.7778H2.22049C1.9258 12.7778 1.64319 12.8949 1.43481 13.1033C1.22644 13.3116 1.10938 13.5943 1.10938 13.8889V17.2223C1.10938 17.517 1.22644 17.7996 1.43481 18.008C1.64319 18.2163 1.9258 18.3334 2.22049 18.3334H7.77604C8.07073 18.3334 8.35334 18.2163 8.56172 18.008C8.77009 17.7996 8.88715 17.517 8.88715 17.2223V13.8889C8.88715 13.5943 8.77009 13.3116 8.56172 13.1033C8.35334 12.8949 8.07073 12.7778 7.77604 12.7778ZM2.22049 17.2223V13.8889H7.77604V17.2223H2.22049Z"
      fill={color}
    />
    <path
      d="M17.776 12.7778H12.2205C11.9258 12.7778 11.6432 12.8949 11.4348 13.1033C11.2264 13.3116 11.1094 13.5943 11.1094 13.8889V17.2223C11.1094 17.517 11.2264 17.7996 11.4348 18.008C11.6432 18.2163 11.9258 18.3334 12.2205 18.3334H17.776C18.0707 18.3334 18.3533 18.2163 18.5617 18.008C18.7701 17.7996 18.8871 17.517 18.8871 17.2223V13.8889C18.8871 13.5943 18.7701 13.3116 18.5617 13.1033C18.3533 12.8949 18.0707 12.7778 17.776 12.7778ZM12.2205 17.2223V13.8889H17.776V17.2223H12.2205Z"
      fill={color}
    />
    <path
      d="M7.22049 7.22206H12.776C13.0707 7.22206 13.3533 7.105 13.5617 6.89662C13.7701 6.68825 13.8871 6.40563 13.8871 6.11095V2.77761C13.8871 2.48293 13.7701 2.20031 13.5617 1.99194C13.3533 1.78357 13.0707 1.6665 12.776 1.6665H7.22049C6.9258 1.6665 6.64319 1.78357 6.43481 1.99194C6.22644 2.20031 6.10938 2.48293 6.10938 2.77761V6.11095C6.10938 6.40563 6.22644 6.68825 6.43481 6.89662C6.64319 7.105 6.9258 7.22206 7.22049 7.22206ZM7.22049 2.77761H12.776V6.11095H7.22049V2.77761Z"
      fill={color}
    />
    <path
      d="M12.776 1.6665H7.22049C6.60684 1.6665 6.10938 2.16397 6.10938 2.77761V6.11095C6.10938 6.7246 6.60684 7.22206 7.22049 7.22206H12.776C13.3897 7.22206 13.8871 6.7246 13.8871 6.11095V2.77761C13.8871 2.16397 13.3897 1.6665 12.776 1.6665Z"
      fill={color}
    />
  </svg>
);
